import { apiRequest } from "../../apiCall";



class shortLinkService {

  /**
 * Post Tenant Member Invitation
 * @returns
 */
  async getShortLinkData(key: string): Promise<any> {
    try {
      const response = await apiRequest("SiteShortLink.GetByShortLink", {}, `?shortLink=${key}`);
      return response
    } catch (error: any) {
      throw error
    }


  }



}

export default new shortLinkService();